export const DRAWER_CONFIG = [
  {
    label: "Orders",
    route: `orders`,
  },
  {
    label: "Customers",
    route: `customers`,
  },
  {
    label: "Products",
    route: `products`,
  },
  {
    label: "Invites",
    route: `invites`,
  },
  {
    label: "Terms",
    route: `terms`,
  },
];
